/*
  Opens the FrontrowMD "Clinicians' Choice" modal from ordinary page markup.

  FrontrowMD's sticker script listens on `window` for a bare string message and
  opens its own modal in response, so a trigger does not have to live inside
  their iframe:

      window.addEventListener("message", ev => {
        if (ev.data === "OPEN_MODAL_STICKER") return openFrModal(...);
      });

  That listener and the modal it shows are both set up when the script loads,
  independent of the badge iframe -- which is what lets the theme render its own
  badge and drop theirs.
*/
(function () {
  if (window.__frontrowCcTrigger) return;
  window.__frontrowCcTrigger = true;

  var MESSAGE = 'OPEN_MODAL_STICKER';
  // The script injects its modals as `.iframe.frontrow`. Their presence means
  // it has run, and therefore that the message above has a listener.
  var READY = function () { return document.querySelector('.iframe.frontrow'); };

  function open() {
    if (READY()) {
      window.postMessage(MESSAGE, '*');
      return;
    }

    /*
      The widget script is async, so a fast click can land before it runs.
      Rather than dropping that click, wait for the script and then open --
      giving up after ~3s so a blocked or failed script cannot leave a timer
      running or fire the modal long after the visitor moved on.
    */
    var tries = 0;
    var timer = setInterval(function () {
      if (READY()) {
        clearInterval(timer);
        window.postMessage(MESSAGE, '*');
      } else if (++tries > 30) {
        clearInterval(timer);
      }
    }, 100);
  }

  // Delegated: the badge may be rendered by a section that loads after this.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-frontrow-cc-open]');
    if (!trigger) return;
    event.preventDefault();
    open();
  });
})();
